import type { ReactNode } from 'react'

import styled from 'styled-components'

import { solidStyling } from './Solid'

type Props = {
	fullWidth?: boolean
	label: ReactNode
	type?: 'default' | 'dark'
	size?: 'default' | 'small'
}

export const LinkSolidNative = styled.a.attrs<Props>(({ label }) => ({
	children: label,
}))<Props>`
	${solidStyling};
`
